import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const data = await api.session(sid);
        setUser(data.user);
        // Clean hash
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error(e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="mono text-kinetic animate-pulse" data-testid="auth-callback-loading">AUTHENTICATING…</div>
    </div>
  );
}
